export enum ExtendedField {
    GET_EXTENDED_FIELD = 'GET_EXTENDED_FIELD',
    GET_EXTENDED_FIELD_SUCCESS = 'GET_EXTENDED_FIELD_SUCCESS',
    GET_EXTENDED_FIELD_FAIL = 'GET_EXTENDED_FIELD_FAIL',
  
    MANAGE_EXTENDED_FIELD_DRAWER = 'MANAGE_EXTENDED_FIELD_DRAWER',
    MANAGE_EXTENDED_FIELD_DRAWER_SUCCESS = 'MANAGE_EXTENDED_FIELD_DRAWER_SUCCESS',
    MANAGE_EXTENDED_FIELD_DRAWER_FAIL = 'MANAGE_EXTENDED_FIELD_DRAWER_FAIL',

    GET_EXTENDED_FIELD_META_DATA = "GET_EXTENDED_FIELD_META_DATA",
    GET_EXTENDED_FIELD_META_DATA_SUCCESS = "GET_EXTENDED_FIELD_META_DATA_SUCCESS",
    GET_EXTENDED_FIELD_META_DATA_FAIL = "GET_EXTENDED_FIELD_META_DATA_FAIL",

    UPDATE_EXTENDED_FIELD = "UPDATE_EXTENDED_FIELD",
    UPDATE_EXTENDED_FIELD_SUCCESS = "UPDATE_EXTENDED_FIELD_SUCCESS",
    UPDATE_EXTENDED_FIELD_FAILURE = "UPDATE_EXTENDED_FIELD_FAILURE",
  
    DELETE_EXTENDED_FIELD = "DELETE_EXTENDED_FIELD",
    DELETE_EXTENDED_FIELD_SUCCESS = "DELETE_EXTENDED_FIELD_SUCCESS",
    DELETE_EXTENDED_FIELD_FAILURE = "DELETE_EXTENDED_FIELD_FAILURE",
  }